import { render, staticRenderFns } from "./studentComplaints.vue?vue&type=template&id=93dae4d8&scoped=true&"
import script from "./studentComplaints.vue?vue&type=script&lang=js&"
export * from "./studentComplaints.vue?vue&type=script&lang=js&"
import style0 from "./studentComplaints.vue?vue&type=style&index=0&id=93dae4d8&lang=scss&scoped=true&"
import style1 from "./studentComplaints.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./studentComplaints.vue?vue&type=style&index=2&id=93dae4d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93dae4d8",
  null
  
)

export default component.exports